
            import "data:text/css,.m-indicator-97066335ac%7Bbackground-color:red%7D";
            const result = {"indicator":"m-indicator-97066335ac"};
            export default result;
          